<template>
  <div class="ai-writing-container">
    <!-- 右侧主要内容区 -->
    <div class="main-content">
      <!-- 功能介绍横幅 -->
      <div class="intro-banner">
        <div class="banner-content">
          <div class="banner-text">
            <h2><i class="el-icon-magic-stick"></i> AI智能写作助手</h2>
            <p>基于先进的AI技术，帮您快速生成高质量文章内容</p>
            <!-- <div class="feature-tags">
              <el-tag type="success" size="small">发言稿</el-tag>
              <el-tag type="primary" size="small">工作总结</el-tag>
              <el-tag type="warning" size="small">营销文案</el-tag>
              <el-tag type="danger" size="small">学生评语</el-tag>
              <el-tag type="info" size="small">节日祝福</el-tag>
              <el-tag size="small">自定义创作</el-tag>
            </div> -->
          </div>
          <!-- <div class="banner-stats">
            <div class="stat-item">
              <div class="stat-number">10,000+</div>
              <div class="stat-label">用户使用</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">50万+</div>
              <div class="stat-label">文章生成</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">98%</div>
              <div class="stat-label">满意度</div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- 写作模板选择区域 -->
      <!-- <div class="template-section">
        <el-card class="template-card" shadow="hover">
          <div slot="header" class="section-header">
            <span><i class="el-icon-collection"></i> 选择写作类型</span>
            <el-button size="small" type="text" @click="showAllTemplates = !showAllTemplates">
              {{ showAllTemplates ? '收起' : '查看全部' }}
            </el-button>
          </div>

          <div class="template-grid">
            <div 
              v-for="template in displayTemplates" 
              :key="template.id"
              class="template-item"
              :class="{ active: selectedTemplate.id === template.id }"
              @click="selectTemplate(template)"
            >
              <div class="template-icon">
                <i :class="template.icon"></i>
              </div>
              <div class="template-info">
                <h4>{{ template.name }}</h4>
                <p>{{ template.description }}</p>
                <div class="template-tags">
                  <el-tag 
                    v-for="tag in template.tags" 
                    :key="tag" 
                    size="mini" 
                    type="info"
                  >
                    {{ tag }}
                  </el-tag>
                </div>
              </div>
              <div class="template-badge" v-if="template.hot">
                <span>热门</span>
              </div>
            </div>
          </div>
        </el-card>
      </div> -->

      <!-- 写作表单区域 -->
      <div class="writing-form-section">
        <el-row :gutter="20">
          <!-- 左侧：输入表单 -->
          <el-col :span="14">
            <el-card class="form-card" shadow="hover">
              <div slot="header" class="section-header">
                <span><i class="el-icon-edit-outline"></i> {{ selectedTemplate.name }}创作</span>
                <div>
                  <el-button size="small" @click="loadExample">加载示例</el-button>
                  <el-button size="small" @click="clearForm">清空内容</el-button>
                </div>
              </div>

              <el-form :model="formData" :rules="formRules" ref="writingForm" label-width="120px">
                <!-- 动态表单字段 -->
                <el-form-item 
                  v-for="field in selectedTemplate.fields" 
                  :key="field.key"
                  :label="field.label"
                  :prop="field.key"
                  :required="field.required"
                >
                  <!-- 单行输入 -->
                  <el-input
                    v-if="field.type === 'input'"
                    v-model="formData[field.key]"
                    :placeholder="field.placeholder"
                    :maxlength="field.maxLength"
                    show-word-limit
                  ></el-input>

                  <!-- 多行输入 -->
                  <el-input
                    v-else-if="field.type === 'textarea'"
                    v-model="formData[field.key]"
                    type="textarea"
                    :rows="field.rows || 4"
                    :placeholder="field.placeholder"
                    :maxlength="field.maxLength"
                    show-word-limit
                  ></el-input>

                  <!-- 选择框 -->
                  <el-select
                    v-else-if="field.type === 'select'"
                    v-model="formData[field.key]"
                    :placeholder="field.placeholder"
                    style="width: 100%;"
                  >
                    <el-option 
                      v-for="option in field.options" 
                      :key="option.value"
                      :label="option.label" 
                      :value="option.value"
                    ></el-option>
                  </el-select>

                  <!-- 数字输入 -->
                  <el-input-number
                    v-else-if="field.type === 'number'"
                    v-model="formData[field.key]"
                    :min="field.min"
                    :max="field.max"
                    :placeholder="field.placeholder"
                    style="width: 100%;"
                  ></el-input-number>

                  <!-- 日期选择 -->
                  <el-date-picker
                    v-else-if="field.type === 'date'"
                    v-model="formData[field.key]"
                    type="date"
                    :placeholder="field.placeholder"
                    style="width: 100%;"
                  ></el-date-picker>

                  <!-- 多选框 -->
                  <el-checkbox-group 
                    v-else-if="field.type === 'checkbox'"
                    v-model="formData[field.key]"
                  >
                    <el-checkbox 
                      v-for="option in field.options" 
                      :key="option.value"
                      :label="option.value"
                    >
                      {{ option.label }}
                    </el-checkbox>
                  </el-checkbox-group>

                  <div class="field-help" v-if="field.help">
                    <i class="el-icon-info"></i>
                    {{ field.help }}
                  </div>
                </el-form-item>

                <!-- 高级选项 -->
                <el-collapse class="advanced-options">
                  <el-collapse-item title="高级选项" name="advanced">
                    <el-form-item label="文章长度">
                      <el-radio-group v-model="advancedOptions.length">
                        <el-radio label="short">简短 (300-500字)</el-radio>
                        <el-radio label="medium">中等 (500-800字)</el-radio>
                        <el-radio label="long">详细 (800-1500字)</el-radio>
                      </el-radio-group>
                    </el-form-item>

                    <el-form-item label="写作风格">
                      <el-select v-model="advancedOptions.style" placeholder="选择写作风格">
                        <el-option label="正式严谨" value="formal"></el-option>
                        <el-option label="轻松活泼" value="casual"></el-option>
                        <el-option label="专业技术" value="professional"></el-option>
                        <el-option label="温馨感人" value="warm"></el-option>
                        <el-option label="幽默风趣" value="humorous"></el-option>
                      </el-select>
                    </el-form-item>

                    <!-- <el-form-item label="语言特色">
                      <el-checkbox-group v-model="advancedOptions.features">
                        <el-checkbox label="rich_vocabulary">丰富词汇</el-checkbox>
                        <el-checkbox label="metaphor">善用比喻</el-checkbox>
                        <el-checkbox label="data_support">数据支撑</el-checkbox>
                        <el-checkbox label="emotional">情感丰富</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item> -->
                  </el-collapse-item>
                </el-collapse>

                <!-- 生成按钮 -->
                <el-form-item class="generate-section">
                  <el-button 
                    type="primary" 
                    size="large"
                    :loading="generating"
                    @click="generateContent"
                    class="generate-btn"
                  >
                    <i class="el-icon-magic-stick"></i>
                    {{ generating ? 'AI正在创作中...' : 'AI智能生成' }}
                  </el-button>
                  <p class="generate-tip">
                    <i class="el-icon-info"></i>
                    AI将根据您的输入智能生成高质量内容，通常需要10-30秒
                  </p>
                </el-form-item>
              </el-form>
            </el-card>
          </el-col>

          <!-- 右侧：示例和帮助 -->
          <el-col :span="10">
            <el-card class="example-card" shadow="hover">
              <div slot="header" class="section-header">
                <span><i class="el-icon-view"></i> 示例参考</span>
                <el-button size="small" type="text" @click="refreshExample">换一个</el-button>
              </div>

              <div class="example-content">
                <div class="example-input">
                  <h4>输入示例：</h4>
                  <div class="example-form">
                    <div 
                      v-for="(value, key) in currentExample.input" 
                      :key="key"
                      class="example-field"
                    >
                      <label>{{ getFieldLabel(key) }}:</label>
                      <div class="field-value">{{ value }}</div>
                    </div>
                  </div>
                </div>

                <div class="example-output">
                  <h4>生成效果：</h4>
                  <div class="output-preview">
                    {{ currentExample.output }}
                  </div>
                  <div class="example-actions">
                    <el-button size="mini" @click="useExample">使用此示例</el-button>
                    <el-button size="mini" type="text" @click="viewFullExample">查看完整</el-button>
                  </div>
                </div>
              </div>
            </el-card>

            <!-- 功能介绍卡片 -->
            <el-card class="feature-card" shadow="hover">
              <div slot="header">
                <span><i class="el-icon-question"></i> 使用说明</span>
              </div>
              
              <div class="feature-content">
                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="el-icon-edit"></i>
                  </div>
                  <div class="feature-text">
                    <h5>多种文体支持</h5>
                    <p>支持发言稿、工作总结、营销文案、学生评语、节日祝福等20+种文体类型</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="el-icon-cpu"></i>
                  </div>
                  <div class="feature-text">
                    <h5>AI智能创作</h5>
                    <p>基于先进的AI大模型，理解您的需求，生成高质量、原创性的文章内容</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="el-icon-setting"></i>
                  </div>
                  <div class="feature-text">
                    <h5>个性化定制</h5>
                    <p>支持自定义长度、风格、语言特色等参数，满足不同场景的写作需求</p>
                  </div>
                </div>

                <div class="feature-item">
                  <div class="feature-icon">
                    <i class="el-icon-time"></i>
                  </div>
                  <div class="feature-text">
                    <h5>快速高效</h5>
                    <p>秒级响应，快速生成，大幅提升写作效率，节省您的宝贵时间</p>
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- 生成结果区域 -->
      <div v-if="generatedContent" class="result-section">
        <el-card class="result-card" shadow="hover">
          <div slot="header" class="result-header">
            <span><i class="el-icon-document"></i> 生成结果</span>
            <div class="result-actions">
              <el-button size="small" @click="regenerateContent" :loading="generating">
                <i class="el-icon-refresh"></i> 重新生成
              </el-button>
              <!-- <el-button size="small" @click="optimizeContent">
                <i class="el-icon-magic-stick"></i> 优化润色
              </el-button> -->
              <el-button size="small" @click="copyContent">
                <i class="el-icon-document-copy"></i> 复制内容
              </el-button>
              <!-- <el-button size="small" @click="saveContent" type="primary">
                <i class="el-icon-folder"></i> 保存文档
              </el-button> -->
            </div>
          </div>

          <div class="result-content">
            <div class="content-meta">
              <div class="meta-item">
                <span class="meta-label">文章类型:</span>
                <el-tag size="mini">{{ selectedTemplate.name }}</el-tag>
              </div>
              <div class="meta-item">
                <span class="meta-label">字数统计:</span>
                <span>{{ contentWordCount }} 字</span>
              </div>
              <div class="meta-item">
                <span class="meta-label">生成时间:</span>
                <span>{{ generationTime }}</span>
              </div>
              <!-- <div class="meta-item">
                <span class="meta-label">质量评分:</span>
                <el-rate v-model="contentQuality" disabled show-score></el-rate>
              </div> -->
            </div>

            <div class="content-editor">
              <el-input
                v-model="generatedContent"
                type="textarea"
                :rows="20"
                placeholder="生成的内容将在这里显示..."
                class="content-textarea"
              ></el-input>
            </div>

            <!-- <div class="content-tools">
              <div class="tool-group">
                <span class="tool-label">快速操作:</span>
                <el-button-group>
                  <el-button size="mini" @click="formatContent">格式化</el-button>
                  <el-button size="mini" @click="checkGrammar">语法检查</el-button>
                  <el-button size="mini" @click="translateContent">翻译</el-button>
                  <el-button size="mini" @click="summarizeContent">生成摘要</el-button>
                </el-button-group>
              </div>
              <div class="tool-group">
                <span class="tool-label">导出格式:</span>
                <el-button-group>
                  <el-button size="mini" @click="exportTxt">TXT</el-button>
                  <el-button size="mini" @click="exportWord">Word</el-button>
                  <el-button size="mini" @click="exportPdf">PDF</el-button>
                  <el-button size="mini" @click="exportMarkdown">Markdown</el-button>
                </el-button-group>
              </div>
            </div> -->
          </div>
        </el-card>
      </div>

      <!-- 最近创作历史 -->
      <div class="history-section">
        <el-card class="history-card" shadow="hover">
          <div slot="header" class="section-header">
            <span><i class="el-icon-time"></i> 最近创作</span>
            <!-- <el-button size="small" type="text" @click="viewAllHistory">查看全部</el-button> -->
          </div>

          <div class="history-list">
            <div 
              v-for="item in recentHistory" 
              :key="item.id"
              class="history-item"
            >
              <div class="history-icon">
                <i :class="getTemplateIcon(item.type)"></i>
              </div>
              <div class="history-info" @click="viewHistoryDetail(item)">
                <h5>{{ item.type_text }}</h5>
                <div class="history-meta">
                  <span>{{ item.wordCount }}字</span>
                  <span>{{ item.createtime_text }}</span>
                </div>
                <div class="history-preview">{{ item.content }}</div>
              </div>
              <div class="history-actions">
                <!-- <el-button size="mini" type="text" @click="editHistory(item)">
                  <i class="el-icon-edit"></i> 编辑
                </el-button> -->
                <el-button size="mini" type="text" @click="copyHistory(item)">
                  <i class="el-icon-document-copy"></i> 复制
                </el-button>
                <el-dropdown @command="handleHistoryCommand">
                  <span class="el-dropdown-link">
                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <!-- <el-dropdown-item :command="{action: 'regenerate', item: item}">重新生成</el-dropdown-item>
                    <el-dropdown-item :command="{action: 'favorite', item: item}">添加收藏</el-dropdown-item>
                    <el-dropdown-item :command="{action: 'share', item: item}">分享</el-dropdown-item> -->
                    <el-dropdown-item :command="{action: 'download', item: item}">下载</el-dropdown-item>
                    <el-dropdown-item divided :command="{action: 'delete', item: item}">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            
            <!-- 空状态 -->
            <div v-if="recentHistory.length === 0" class="empty-history">
              <i class="el-icon-document"></i>
              <p>暂无创作历史</p>
              <p>开始您的第一次AI创作吧！</p>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <!-- 查看完整示例弹窗 -->
    <el-dialog
      title="完整示例预览"
      :visible.sync="showExampleDialog"
      width="70%"
      class="example-dialog"
    >
      <div class="full-example-content">
        <div class="example-section">
          <h3>输入信息</h3>
          <el-descriptions :column="2" border>
            <el-descriptions-item 
              v-for="(value, key) in currentExample.input"
              :key="key"
              :label="getFieldLabel(key)"
            >
              {{ value }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        
        <div class="example-section">
          <h3>生成内容</h3>
          <div class="full-output">
            {{ currentExample.fullOutput || currentExample.output }}
          </div>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="showExampleDialog = false">关 闭</el-button>
        <el-button type="primary" @click="useExampleAndClose">使用此示例</el-button>
      </span>
    </el-dialog>

    <!-- 历史详情弹窗 -->
    <el-dialog
      title="创作详情"
      :visible.sync="showHistoryDialog"
      width="80%"
      class="history-dialog"
    >
      <div v-if="currentHistoryItem" class="history-detail-content">
        <div class="detail-header">
          <h2>{{ currentHistoryItem.title }}</h2>
          <div class="detail-meta">
            <el-tag size="small">{{ currentHistoryItem.type_text }}</el-tag>
            <span>{{ currentHistoryItem.wordCount }}字</span>
            <span>{{ currentHistoryItem.createTime }}</span>
          </div>
        </div>
        
        <div class="detail-content">
          <el-input
            v-model="currentHistoryItem.content"
            type="textarea"
            :rows="25"
            readonly
          ></el-input>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="showHistoryDialog = false">关 闭</el-button>
        <el-button @click="copyHistory(currentHistoryItem)">复制内容</el-button>
        <!-- <el-button type="primary" @click="editHistory(currentHistoryItem)">编辑使用</el-button> -->
      </span>
    </el-dialog>

    <!-- 分享弹窗 -->
    <el-dialog
      title="分享创作"
      :visible.sync="showShareDialog"
      width="50%"
      class="share-dialog"
    >
      <div class="share-content">
        <div class="share-options">
          <div class="share-option" @click="shareToWeChat">
            <i class="el-icon-chat-line-square"></i>
            <span>微信</span>
          </div>
          <div class="share-option" @click="shareToWeibo">
            <i class="el-icon-share"></i>
            <span>微博</span>
          </div>
          <div class="share-option" @click="shareToQQ">
            <i class="el-icon-chat-dot-square"></i>
            <span>QQ</span>
          </div>
          <div class="share-option" @click="copyShareLink">
            <i class="el-icon-link"></i>
            <span>复制链接</span>
          </div>
        </div>
        
        <div class="share-link">
          <el-input
            v-model="shareLink"
            readonly
            placeholder="分享链接"
          >
            <el-button slot="append" @click="copyShareLink">复制</el-button>
          </el-input>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AIWriting',
  data() {
    return {
      page:1,
      showAllTemplates: false,
      showExampleDialog: false,
      showHistoryDialog: false,
      showShareDialog: false,
      generating: false,
      generatedContent: '',
      contentWordCount: 0,
      contentQuality: 4.5,
      generationTime: '',
      currentHistoryItem: null,
      shareLink: '',
      
      // 表单数据
      formData: {},
      formRules: {},
      
      // 高级选项
      advancedOptions: {
        length: 'medium',
        style: 'formal',
        features: []
      },
      
      // 当前选中的模板
      selectedTemplate: {},
      
      // 当前示例
      currentExample: {},
      
      writingTemplates:[
        {
          id: 'custom',
          name: '自定义创作',
          description: '根据您的具体需求自由创作各种类型文章',
          icon: 'el-icon-magic-stick',
          hot: false,
          tags: ['自定义', '灵活', '创意'],
          fields: [
            {
              key: 'content_type',
              label: '内容类型',
              type: 'input',
              placeholder: '例如：发言稿、工作总结、营销文案、活动策划、节日祝福等',
              required: true,
              maxLength: 50,
              help: '请简要描述您要创作的内容类型'
            },
            {
              key: 'target_audience',
              label: '目标读者',
              type: 'input',
              placeholder: '例如：公司员工、客户群体、学生家长、社区居民等',
              required: true,
              maxLength: 50,
              help: '明确读者有助于调整写作风格和语言'
            },
            {
              key: 'main_purpose',
              label: '写作目的',
              type: 'textarea',
              placeholder: '请详细描述您的写作目的和希望达到的效果',
              required: true,
              rows: 3,
              maxLength: 200,
              help: '清晰的目的有助于生成更精准的内容'
            },
            {
              key: 'key_information',
              label: '关键信息',
              type: 'textarea',
              placeholder: '请提供所有相关的关键信息、数据、要点等，每行一个要点',
              required: true,
              rows: 6,
              maxLength: 500,
              help: '信息越详细，生成的内容越准确'
            },
            {
              key: 'special_requirements',
              label: '特殊要求',
              type: 'textarea',
              placeholder: '例如：需要包含特定词汇、遵循特定格式、体现某种情感等',
              rows: 3,
              maxLength: 200,
              help: '可选项，有特殊需求请详细说明'
            }
          ],
          examples: [
            {
              input: {
                content_type: '公司搬迁通知',
                target_audience: '全体员工',
                main_purpose: '通知员工公司即将搬迁，告知新地址、搬迁时间安排，确保工作平稳过渡',
                key_information: '搬迁时间：2024年3月15日\n新地址：XX市XX区XX大厦18层\n搬迁期间：3月13-14日暂停办公\n新办公室设施更完善\n交通更便利',
                special_requirements: '语气正式但亲切，强调搬迁的积极意义'
              },
              output: '关于公司搬迁的通知\n\n各位同事：\n\n为了公司更好的发展...',
              fullOutput: '关于公司搬迁的通知\n\n各位同事：\n\n为了公司更好的发展，经管理层研究决定，我公司将于2024年3月15日正式搬迁至新办公地址...'
            },
            {
              input: {
                content_type: '产品使用说明',
                target_audience: '产品用户',
                main_purpose: '帮助用户快速了解产品功能，正确使用产品，提升用户体验',
                key_information: '产品名称：智能语音音箱\n主要功能：语音控制、音乐播放、智能家居控制\n操作步骤：开机-连接WiFi-语音唤醒-下达指令\n注意事项：防水防潮、定期清洁',
                special_requirements: '语言简洁易懂，步骤清晰，适合各年龄段用户'
              },
              output: '智能语音音箱使用指南\n\n欢迎使用我们的智能语音音箱...',
              fullOutput: '智能语音音箱使用指南\n\n欢迎使用我们的智能语音音箱！本指南将帮助您快速上手，享受智能生活的便利...'
            }
          ]
        }
      ],
      // 写作模板
      
      // 最近创作历史
      recentHistory: [
        {
          id: 1,
          title: '2024年度工作总结报告',
          type: '工作总结',
          wordCount: 1250,
          createTime: '2024-01-15 14:30',
          preview: '本年度在公司领导的正确指导下，我认真履行职责...',
          content: '2024年度工作总结报告\n\n本年度在公司领导的正确指导下，我认真履行职责，积极完成各项工作任务。现将一年来的工作情况总结如下：\n\n一、工作概述\n作为产品经理，我主要负责产品规划、需求分析、项目管理等工作...\n\n二、主要成绩\n1. 成功完成3个重要产品功能的上线\n2. 用户活跃度提升25%，达到历史新高\n3. 收到客户好评反馈120+条，满意度达98%\n\n三、工作亮点\n...'
        },
        {
          id: 2,
          title: '新产品发布会发言稿',
          type: '发言稿',
          wordCount: 680,
          createTime: '2024-01-14 16:20',
          preview: '尊敬的各位来宾，女士们、先生们，大家好...',
          content: '新产品发布会发言稿\n\n尊敬的各位来宾，女士们、先生们：\n\n大家好！\n\n今天是一个特殊而重要的日子，我们在这里隆重举行新产品发布会。首先，我代表公司全体员工，向各位的到来表示最热烈的欢迎和最诚挚的感谢！\n\n经过团队的不懈努力，我们的新产品终于与大家见面了...'
        },
        {
          id: 3,
          title: '春节员工祝福语',
          type: '节日祝福',
          wordCount: 320,
          createTime: '2024-01-13 09:15',
          preview: '亲爱的同事们，值此新春佳节来临之际...',
          content: '春节员工祝福语\n\n亲爱的同事们：\n\n值此新春佳节来临之际，我谨代表公司管理层向全体员工及家属致以最诚挚的节日祝福和最美好的新年祝愿！\n\n过去的一年里，正是有了大家的辛勤工作和无私奉献，公司才能取得今天的成绩...\n\n新的一年，祝愿大家：\n身体健康，工作顺利！\n家庭和睦，万事如意！\n新年新气象，事业更上层楼！'
        }
      ]
    }
  },
  
  computed: {
    displayTemplates() {
      return this.showAllTemplates ? this.writingTemplates : this.writingTemplates.slice(0, 6);
    }
  },
  
  watch: {
    generatedContent(newVal) {
      this.contentWordCount = newVal.length;
    }
  },
  
  mounted() {
    // 默认选择第一个模板
    this.selectTemplate(this.writingTemplates[0]);
  },
  
  created(){
    this.getList();
  },
  
  methods: {
    async getList(){
      const res = await this.$api.post('/api/production/articleGendrationList', {page:this.page})
      if(res.code == 1){
        this.recentHistory = res.data.list.data;
      }else{
        this.$message.error('数据获取失败');
      }
    },
    // 选择模板
    selectTemplate(template) {
      this.selectedTemplate = template;
      this.formData = {};
      this.currentExample = template.examples && template.examples.length > 0 ? template.examples[0] : {};
      
      // 设置表单验证规则
      this.formRules = {};
      template.fields.forEach(field => {
        if (field.required) {
          this.formRules[field.key] = [
            { required: true, message: `请输入${field.label}`, trigger: 'blur' }
          ];
        }
      });
    },
    
    // 获取字段标签
    getFieldLabel(key) {
      const field = this.selectedTemplate.fields.find(f => f.key === key);
      return field ? field.label : key;
    },
    
    // 获取模板图标
    getTemplateIcon(type) {
      const template = this.writingTemplates.find(t => t.name === type);
      return template ? template.icon : 'el-icon-document';
    },
    
    // 加载示例
    loadExample() {
      if (this.currentExample && this.currentExample.input) {
        Object.keys(this.currentExample.input).forEach(key => {
          this.$set(this.formData, key, this.currentExample.input[key]);
        });
        this.$message.success('示例内容已加载');
      }
    },
    
    // 使用示例
    useExample() {
      this.loadExample();
    },
    
    // 使用示例并关闭弹窗
    useExampleAndClose() {
      this.loadExample();
      this.showExampleDialog = false;
    },
    
    // 刷新示例
    refreshExample() {
      const examples = this.selectedTemplate.examples;
      if (examples && examples.length > 0) {
        const currentIndex = examples.indexOf(this.currentExample);
        const nextIndex = (currentIndex + 1) % examples.length;
        this.currentExample = examples[nextIndex];
      }
    },
    
    // 查看完整示例
    viewFullExample() {
      this.showExampleDialog = true;
    },
    
    // 清空表单
    clearForm() {
      this.$confirm('确定清空所有输入内容吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData = {};
        this.$message.success('内容已清空');
      });
    },
    
    // 生成内容
    generateContent() {
      this.$refs.writingForm.validate((valid) => {
        if (valid) {
          this.generating = true;
          this.generationTime = new Date().toLocaleString();
          
          // 模拟API调用
          //setTimeout(() => {
            this.callGenerateAPI();
          //}, Math.random() * 20000 + 10000); // 10-30秒随机延迟
        } else {
          this.$message.error('请完善必填信息');
        }
      });
    },
    
    // 调用生成API
    async callGenerateAPI() {
      try {
        const result = Object.assign({}, this.formData, this.advancedOptions);
        const res = await this.$api.post('/api/production/articleGeneration', result)
        
        if (res.code == 1) {
          this.generatedContent = res.data.content;
          this.contentQuality = (Math.random() * 2 + 3).toFixed(1);
          this.$message.success(res.msg || '内容生成成功！');
        } else {
          this.$message.error(res.msg || '生成失败，请重试');
        }
      } catch (error) {
        this.$message.error('生成过程中出现错误，请重试');
      } finally {
        this.generating = false;
      }
    },
    
    // 重新生成
    regenerateContent() {
      this.generateContent();
    },
    
    // 优化内容
    optimizeContent() {
      if (!this.generatedContent) {
        this.$message.warning('请先生成内容');
        return;
      }
      this.$message.info('内容优化功能开发中...');
    },
    
    // 复制内容
    copyContent() {
      if (this.generatedContent) {
        navigator.clipboard.writeText(this.generatedContent).then(() => {
          this.$message.success('内容已复制到剪贴板');
        }).catch(() => {
          this.$message.error('复制失败');
        });
      }
    },
    
    // 保存内容
    saveContent() {
      if (this.generatedContent) {
        const title = this.formData[this.selectedTemplate.fields[0].key] || '未命名文档';
        const newItem = {
          id: Date.now(),
          title: title,
          type: this.selectedTemplate.name,
          wordCount: this.contentWordCount,
          createTime: new Date().toLocaleString(),
          content: this.generatedContent,
          preview: this.generatedContent.substring(0, 50) + '...'
        };
        this.recentHistory.unshift(newItem);
        this.$message.success('文档已保存');
      }
    },
    
    // 内容工具方法
    formatContent() {
      this.$message.info('格式化功能开发中...');
    },
    
    checkGrammar() {
      this.$message.info('语法检查功能开发中...');
    },
    
    translateContent() {
      this.$message.info('翻译功能开发中...');
    },
    
    summarizeContent() {
      this.$message.info('摘要生成功能开发中...');
    },
    
    // 导出功能
    exportTxt() {
      if (this.generatedContent) {
        const blob = new Blob([this.generatedContent], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'ai_writing_content.txt';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.$message.success('TXT文件导出成功');
      }
    },
    
    exportWord() {
      this.$message.info('Word导出功能开发中...');
    },
    
    exportPdf() {
      this.$message.info('PDF导出功能开发中...');
    },
    
    exportMarkdown() {
      if (this.generatedContent) {
        const blob = new Blob([this.generatedContent], { type: 'text/markdown;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'ai_writing_content.md';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        this.$message.success('Markdown文件导出成功');
      }
    },
    
    // 历史记录相关方法
    viewHistoryDetail(item) {
      this.currentHistoryItem = item;
      this.showHistoryDialog = true;
    },
    
    editHistory(item) {
      // 根据历史记录的类型找到对应模板
      const template = this.writingTemplates.find(t => t.name === item.type);
      if (template) {
        this.selectTemplate(template);
        // 清空当前表单数据
        this.formData = {};
        // 将历史内容加载到生成结果区域
        this.generatedContent = item.content;
        this.contentWordCount = item.content.length;
        this.generationTime = item.createTime;
        this.$message.success('历史内容已加载到编辑区域');
        // 滚动到表单区域
        this.$nextTick(() => {
          document.querySelector('.writing-form-section').scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        });
      } else {
        this.$message.error('未找到对应的模板类型');
      }
      this.showHistoryDialog = false;
    },
    
    copyHistory(item) {
      navigator.clipboard.writeText(item.content).then(() => {
        this.$message.success('内容已复制到剪贴板');
      }).catch(() => {
        this.$message.error('复制失败');
      });
      this.showHistoryDialog = false;
    },
    
    handleHistoryCommand(command) {
      const { action, item } = command;
      
      switch (action) {
        case 'regenerate':
          this.regenerateHistory(item);
          break;
        case 'favorite':
          this.favoriteHistory(item);
          break;
        case 'share':
          this.shareHistory(item);
          break;
        case 'download':
          this.downloadHistory(item);
          break;
        case 'delete':
          this.deleteHistory(item);
          break;
      }
    },
    
    regenerateHistory(item) {
      // 加载对应模板和内容，然后重新生成
      const template = this.writingTemplates.find(t => t.name === item.type);
      if (template) {
        this.selectTemplate(template);
        this.generateContent();
        this.$message.info('正在重新生成内容...');
      }
    },
    
    favoriteHistory(item) {
      // 实际项目中应该调用API将项目添加到收藏
      this.$message.success('已添加到收藏');
    },
    
    shareHistory(item) {
      this.currentHistoryItem = item;
      this.shareLink = `https://example.com/share/${item.id}`; // 实际项目中应该生成真实的分享链接
      this.showShareDialog = true;
    },
    
    downloadHistory(item) {
      const blob = new Blob([item.content], { type: 'text/plain;charset=utf-8' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${item.type_text}.txt`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      this.$message.success('文件下载成功');
    },
    
    deleteHistory(item) {
      this.$confirm(`确定删除"${item.title}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$api.post('/api/production/articleGendrationDel', {id:item.id})
        if(res.code == 1){
          const index = this.recentHistory.findIndex(h => h.id === item.id);
          if (index > -1) {
            this.recentHistory.splice(index, 1);
            this.$message.success(res.msg);
          }
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    viewAllHistory() {
      // 实际项目中应该跳转到完整的历史页面
      this.$message.info('跳转到完整历史页面...');
    },
    
    // 分享相关方法
    shareToWeChat() {
      this.$message.info('微信分享功能需要集成微信SDK');
    },
    
    shareToWeibo() {
      this.$message.info('微博分享功能需要集成微博SDK');
    },
    
    shareToQQ() {
      this.$message.info('QQ分享功能需要集成QQSDK');
    },
    
    copyShareLink() {
      navigator.clipboard.writeText(this.shareLink).then(() => {
        this.$message.success('分享链接已复制');
        this.showShareDialog = false;
      }).catch(() => {
        this.$message.error('复制失败');
      });
    }
  }
}
</script>

<style scoped>
.ai-writing-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
}

/* 主内容区 */
.main-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}

/* 介绍横幅 */
.intro-banner {
  background: linear-gradient(135deg, #667eea 0%, #87cfdb 100%);
  border-radius: 12px;
  font-weight: 500;
  padding: 30px;
  margin-bottom: 25px;
  color: white;
  position: relative;
  overflow: hidden;
}

.el-collapse {
  border: none;
}

.el-collapse-item__header {
  background: #f8f9fa;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  padding-left: 15px;
}

.el-collapse-item__wrap {
  border: none;
}

.el-collapse-item__content {
  padding: 15px;
  background: #fafbfc;
  border-radius: 0 0 6px 6px;
}

.el-radio-group,
.el-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.el-select {
  width: 100%;
}

.el-rate {
  height: auto;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  font-size: 12px;
}

.el-dropdown-link:hover {
  color: #66b3ff;
}

.el-descriptions {
  margin-bottom: 20px;
}

/* 滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}


.intro-banner::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.banner-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
}

.banner-text h2 {
  margin: 0 0 10px 0;
  font-size: 28px;
  font-weight: bold;
}

.banner-text p {
  margin: 0 0 20px 0;
  font-size: 16px;
  opacity: 0.9;
}

.feature-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.feature-tags .el-tag {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
}

.banner-stats {
  display: flex;
  gap: 30px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 5px;
}

.stat-label {
  font-size: 14px;
  opacity: 0.8;
}

/* 模板选择区域 */
.template-section {
  margin-bottom: 25px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.template-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 20px 0;
}

.template-item {
  border: 2px solid #e4e7ed;
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  background: white;
}

.template-item:hover {
  border-color: #409eff;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(64, 158, 255, 0.15);
}

.template-item.active {
  border-color: #409eff;
  background: #f0f9ff;
  box-shadow: 0 4px 20px rgba(64, 158, 255, 0.2);
}

.template-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
  font-size: 24px;
  color: #409eff;
}

.template-item.active .template-icon {
  background: #409eff;
  color: white;
}

.template-info h4 {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #303133;
}

.template-info p {
  margin: 0 0 12px 0;
  font-size: 13px;
  color: #606266;
  line-height: 1.5;
}

.template-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.template-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #ff6b6b;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: bold;
}

.template-item.active::after {
  content: '✓';
  position: absolute;
  top: 10px;
  right: 15px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #67c23a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

/* 写作表单区域 */
.writing-form-section {
  margin-bottom: 25px;
}

.form-card {
  height: fit-content;
}

.field-help {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 4px;
}

.advanced-options {
  margin: 20px 0;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.generate-section {
  text-align: center;
  margin: 30px 0 10px 0;
}

.generate-btn {
  padding: 15px 40px;
  font-size: 16px;
  border-radius: 25px;
  box-shadow: 0 4px 15px rgba(64, 158, 255, 0.3);
}

.generate-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(64, 158, 255, 0.4);
}

.generate-tip {
  margin: 15px 0 0 0;
  font-size: 12px;
  color: #909399;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

/* 示例卡片 */
.example-card {
  margin-bottom: 20px;
  height: fit-content;
}

.example-content {
  padding: 10px 0;
}

.example-input {
  margin-bottom: 20px;
}

.example-input h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #303133;
}

.example-form {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  border-left: 4px solid #409eff;
}

.example-field {
  margin-bottom: 10px;
}

.example-field:last-child {
  margin-bottom: 0;
}

.example-field label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}

.field-value {
  font-size: 13px;
  color: #303133;
  margin-top: 2px;
  line-height: 1.4;
}

.example-output h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  color: #303133;
}

.output-preview {
  background: #f0f9ff;
  padding: 15px;
  border-radius: 6px;
  border-left: 4px solid #67c23a;
  font-size: 13px;
  color: #303133;
  line-height: 1.6;
  max-height: 120px;
  overflow: hidden;
  position: relative;
}

.output-preview::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background: linear-gradient(transparent, #f0f9ff);
}

.example-actions {
  margin-top: 10px;
  text-align: center;
}

/* 功能介绍卡片 */
.feature-card {
  height: fit-content;
}

.feature-content {
  padding: 10px 0;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
}

.feature-item:last-child {
  margin-bottom: 0;
}

.feature-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f0f9ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.feature-icon i {
  font-size: 18px;
  color: #409eff;
}

.feature-text h5 {
  margin: 0 0 5px 0;
  font-size: 14px;
  color: #303133;
}

.feature-text p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  line-height: 1.5;
}

/* 生成结果区域 */
.result-section {
  margin-bottom: 25px;
}

.result-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.result-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.result-content {
  padding: 20px 0;
}

.content-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
}

.meta-label {
  color: #606266;
  font-weight: 500;
}

.content-editor {
  margin-bottom: 20px;
}

.content-textarea {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  line-height: 1.8;
}

.content-tools {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
}

.tool-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tool-label {
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

/* 历史记录区域 */
.history-section {
  margin-bottom: 25px;
}

.history-list {
  padding: 15px 0;
}

.history-item {
  display: flex;
  align-items: flex-start;
  padding: 15px 0;
  border-bottom: 1px solid #f0f2f5;
  transition: all 0.3s;
}

.history-item:hover {
  background: #f8f9fa;
  margin: 0 -20px;
  padding-left: 20px;
  padding-right: 20px;
}

.history-item:last-child {
  border-bottom: none;
}

.history-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f0f9ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.history-icon i {
  font-size: 16px;
  color: #409eff;
}

.history-info {
  flex: 1;
  cursor: pointer;
}

.history-info h5 {
  margin: 0 0 5px 0;
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.history-meta {
  display: flex;
  gap: 15px;
  font-size: 12px;
  color: #909399;
  margin-bottom: 5px;
}

.history-preview {
  font-size: 12px;
  color: #606266;
  line-height: 1.4;
  max-height: 34px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.history-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 15px;
}

.empty-history {
  text-align: center;
  padding: 40px 20px;
  color: #909399;
}

.empty-history i {
  font-size: 48px;
  color: #e4e7ed;
  margin-bottom: 16px;
  display: block;
}

.empty-history p {
  margin: 8px 0;
  font-size: 14px;
}

/* 弹窗样式 */
.example-dialog .el-dialog__body {
  padding: 20px;
}

.full-example-content {
  max-height: 60vh;
  overflow-y: auto;
}

.example-section {
  margin-bottom: 25px;
}

.example-section h3 {
  margin: 0 0 15px 0;
  color: #303133;
  font-size: 16px;
}

.full-output {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 6px;
  border-left: 4px solid #67c23a;
  font-size: 14px;
  line-height: 1.8;
  color: #303133;
  white-space: pre-wrap;
}

.dialog-footer {
  text-align: center;
}

/* 历史详情弹窗 */
.history-dialog .detail-header {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e4e7ed;
}

.history-dialog .detail-header h2 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 20px;
}

.detail-meta {
  display: flex;
  gap: 15px;
  align-items: center;
  font-size: 13px;
  color: #909399;
}

.detail-content {
  margin-bottom: 20px;
}

/* 分享弹窗 */
.share-dialog .share-content {
  text-align: center;
}

.share-options {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 30px;
}

.share-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 15px;
  border-radius: 8px;
  transition: all 0.3s;
}

.share-option:hover {
  background: #f0f9ff;
}

.share-option i {
  font-size: 32px;
  color: #409eff;
}

.share-option span {
  font-size: 14px;
  color: #606266;
}

.share-link {
  margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .banner-content {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  
  .banner-stats {
    justify-content: center;
  }
  
  .template-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (max-width: 768px) {
  .main-content {
    padding: 15px;
  }
  
  .intro-banner {
    padding: 20px;
  }
  
  .banner-text h2 {
    font-size: 22px;
  }
  
  .banner-stats {
    flex-direction: row;
    gap: 20px;
  }
  
  .stat-number {
    font-size: 24px;
  }
  
  .template-grid {
    grid-template-columns: 1fr;
  }
  
  .writing-form-section .el-col {
    margin-bottom: 20px;
  }
  
  .result-actions {
    justify-content: center;
  }
  
  .content-tools {
    flex-direction: column;
    gap: 10px;
  }
  
  .tool-group {
    justify-content: center;
  }
  
  .history-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .history-actions {
    align-self: flex-end;
  }
  
  .share-options {
    gap: 20px;
  }
}

/* 动画效果 */
.template-item {
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.result-card {
  animation: slideInDown 0.5s ease-out;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 加载状态 */
.generate-btn.is-loading {
  position: relative;
}

.generate-btn.is-loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 25px;
  background: rgba(64, 158, 255, 0.1);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

/* Element UI 样式覆盖 */
.el-card {
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.el-card__header {
  border-bottom: 1px solid #f0f2f5;
  background: #fafbfc;
}

.el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.el-input__inner,
.el-textarea__inner {
  border-radius: 6px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s;
}

.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.el-button {
  border-radius: 6px;
  font-weight: 500;
}

.el-button--primary {
  background: #409eff;
  border-color: #409eff;
}

.el-button--primary:hover {
  background: #66b3ff;
  border-color: #66b3ff;
}

.el-tag {
  border: none;
  border-radius: 12px;
}
</style>